import { EVENTS } from "../global/constants";

export class Observer {
    constructor() {

    }
    update(event) {
        if ( this.eventIsRelevant(event) ) {
            this.reactToEvent(event)
        }
    }

    eventIsRelevant(event=false) {
        throw new Error("Needs to be implemented");
    }

    reactToEvent() {
        throw new Error("Needs to be implemented");
    }
}

export class BoardsObserver extends Observer {
    constructor(reactFn={}) {
        super();
        this.reactFn = reactFn;
    }

    eventIsRelevant(event) {
        return (event.name === EVENTS.update);
    }

    reactToEvent(event) {
        this.reactFn(event);
    }
}

export class GeneralObserver extends Observer {
    constructor(reactFn={}) {
        super();
        this.reactFn = reactFn;
    }

    eventIsRelevant(event) {
        return (event.name === EVENTS.update);
    }

    reactToEvent(event) {
        this.reactFn(event);
    }
}